import React, { useMemo } from 'react';

import { AlineAlert } from 'src/components/generic/AlineAlert';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  alert: {
    border: `1px solid ${theme.palette.warning.light}`,
    marginBottom: theme.spacing(1),
  },
}));

const privateCommentMentionWarningSuffix = "but they're not in your organization.";

interface PrivateCommentMentionWarningProps {
  users: Array<{ displayName: string; email: string }>;
}

export function PrivateCommentMentionWarning({
  users,
}: PrivateCommentMentionWarningProps): JSX.Element | null {
  const { classes } = useStyles();

  const message = useMemo(() => {
    const names = users.map(user => user.displayName || user.email);
    if (!names.length) return '';

    if (names.length === 1)
      return `You mentioned ${names[0]}, ${privateCommentMentionWarningSuffix}`;
    if (names.length === 2)
      return `You mentioned ${names[0]} and ${names[1]}, ${privateCommentMentionWarningSuffix}`;

    const last = names[names.length - 1];
    const rest = names.slice(0, -1).join(', ');
    return `You mentioned ${rest}, and ${last}, ${privateCommentMentionWarningSuffix}`;
  }, [users]);

  if (!message) return null;

  return (
    <AlineAlert className={classes.alert} severity="warning">
      {message}
    </AlineAlert>
  );
}
